import { useCallback, useState } from 'react'
import { DataTableSortKey } from '../DataTable.types'

export type DataTableSort<TColumnId extends string> = {
    sortKey: DataTableSortKey<TColumnId> | null
    handleSort: (columnId: TColumnId) => void
}

export const useDataTableSort = <TColumnId extends string>(
    defaultSortColumnId?: TColumnId,
    isClearable = false
): DataTableSort<TColumnId> => {
    const [sortKey, setSortKey] = useState<DataTableSortKey<TColumnId> | null>(
        defaultSortColumnId ? { columnId: defaultSortColumnId, direction: 'asc' } : null
    )

    const handleSort = useCallback(
        (columnId: TColumnId) => {
            setSortKey((current) => {
                if (current?.columnId !== columnId) return { columnId, direction: 'asc' }
                if (current.direction === 'asc') return { columnId, direction: 'desc' }

                return isClearable ? null : { columnId, direction: 'asc' }
            })
        },
        [isClearable]
    )

    return { sortKey, handleSort }
}
